module.exports = __webpack_public_path__ + "img/x.38197e1d.svg";